export const getSession = () => {
  return sessionStorage.getItem('legal_link_session');
}

export const storeSession = (session) => {
  sessionStorage.setItem('legal_link_session', session);
}

export const getToken = () => {
    return sessionStorage.getItem('legal_link_token');
}

export const storeToken = (token) => {
    sessionStorage.setItem('legal_link_token', token);
}

export const getLanguage = () => {
    return sessionStorage.getItem('legal_link_language');
}

export const storeLanguage = (language) => {
    sessionStorage.setItem('legal_link_language', language);
}

export const getTimeZone = () => {
    return sessionStorage.getItem('legal_link_timezone');
}

export const storeTimeZone = (timezone) => {
    sessionStorage.setItem('legal_link_timezone', timezone);
}
